import React from 'react';
import AuthService from './authService.js';
import PricingListItem from '../Domain/PricingListItem.js';
import serviceHelper from '../Helpers/serviceHelper.js';
import EligiblePricingItem from '../Domain/EligiblePricingItem.js';
import SearchParams from '../Elements/SearchParams';
import PricingSearchParams from '../Contents/Sales/PricingAdmin/PricingSearchParams';

export default class PricingService extends React.Component {
  static GetPricingItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, PricingSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/Pricing/GetAllPricingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetPricingById(id, clearCache = false) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/Pricing/GetPricingByIdAsync/${id}?clearCache=${clearCache}`
    );
  }

  static GetAvailablePricingStatusChangeActions(id) {
    const url = `/api/Pricing/GetAvailablePricingStatusChangeActions/${id}/?clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static Post(item) {
    const stringItem = serviceHelper.ConvertAllPropertyToString(item);
    const url = '/api/Pricing/PostPricing/';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(stringItem));
  }

  static StatusChange(item) {
    const string = serviceHelper.ConvertAllPropertyToString(item);
    return AuthService.getInstance().CallBackendFunctionPost('/api/Pricing/StatusChange/', JSON.stringify(string));
  }
  static MultiplePost(item) {
    const keys = [];
    Object.keys(item).forEach((key, index) => {
      if (key.includes('Status') && item[key] === false) {
        const data = key.slice(0, -6);
        keys.push(data);
      }
    });

    keys.forEach((c) => {
      delete item[c];
      delete item[`${c}Status`];
      delete item[`${c}Orgin`];
    });

    const itemJson = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPost('/api/Pricing/PricingMultipleAction/', itemJson);
  }

  static AddProjectPricing(item) {
    const string = serviceHelper.ConvertAllPropertyToString(item);
    return AuthService.getInstance().CallBackendFunctionPost('/api/Project/AddProjectPricing/', JSON.stringify(string));
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new PricingListItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static GetEligiblePricingList(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/Pricing/GetEligiblePricingsForCopyAsync/${id}`);
  }

  static ConvertEligiblePricingDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new EligiblePricingItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static ExportAdminExcelAsync(selectedItemIds, type, allItemsInTheSearchSetAreSelected, pricingSearchParams) {
    const url = `/api/Pricing/ExportAdminExcelAsync?selectedItems=${JSON.stringify(
      selectedItemIds
    )}&searchParams=${JSON.stringify(
      pricingSearchParams
    )}&type=${type}&allItemsInTheSearchSetAreSelected=${allItemsInTheSearchSetAreSelected}&clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ExportPricingForOps(searchItem, pricingIds, allItemsInTheSearchSetAreSelected) {
    const data = {
      SearchItem: searchItem,
      PricingIds: pricingIds,
      AllItemsInTheSearchSetAreSelected: allItemsInTheSearchSetAreSelected,
    };
    return AuthService.getInstance().CallBackendFunctionPost('/api/Pricing/ExportPricingForOps/', JSON.stringify(data));
  }
}
